import { Mutation } from 'vuex';
import { IModuleState } from './types';

// 待确认的设计项目列表
export const setAppointmentPages: Mutation<IModuleState> = (state, payload) => {
  state.appointmentPage.data = payload.data;
  state.appointmentPage.total = payload.total;
  state.appointmentPage.pageNum = payload.pageNum;
  state.appointmentPage.pageSize = payload.pageSize;
  state.appointmentPage.loading = !!payload.loading;
};

// 验收项目列表
export const setUserPages: Mutation<IModuleState> = (state, payload) => {
  state.userPage.data = payload.data;
  state.userPage.total = payload.total;
  state.userPage.pageNum = payload.pageNum;
  state.userPage.pageSize = payload.pageSize;
  state.userPage.loading = !!payload.loading;
};

// 普通弹窗
export const setDialog: Mutation<IModuleState> = (state, payload) => {
  state.dialog.type = payload.type;
  state.dialog.data = payload.data;
  state.dialog.visible = !!payload.visible;
  state.dialog.loading = !!payload.loading;
};

// 列表搜索条件
export const setSearch: Mutation<IModuleState> = (state, payload) => {
  state.search = payload;
};

export const setLoading: Mutation<IModuleState> = (state, payload) => {
  state.loading = payload;
};
